import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { EditorEditComponent } from './editor-edit/editor-edit.component';
import { EditorEditModule } from './editor-edit/editor-edit.module';

@NgModule({
  imports: [
    CommonModule,
    EditorEditModule,
    RouterModule.forChild([
      {
        path: "",
        children: [
          {
            path: "",
            redirectTo: "edit",
            pathMatch: "full"
          },
          {
            path: "edit",
            component: EditorEditComponent
          }]
      }
    ])
  ],
})
export class EditorModule { }
